export const FORM_LOGIN_EMPLOYEE = ({ onEnter, branchOptions }) => {
  return [
    {
      name: 'employeeId',
      label: 'รหัสประจำตัวประชาชน',
      type: 'INPUT_PHONE',
      onEnter,
      maxLength: 13,
      rules: {
        required: true,
        pattern: /^[0-9]*$/,
      },
    },
    {
      name: 'branchId',
      label: 'สาขา',
      type: 'DROPDOWN',
      properties: {
        options: branchOptions || [],
      },
      rules: {
        required: true,
      },
    },
  ];
};
